import {AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';
import type * as React from 'react';
import LoginDisplay from '@/components/LoginDisplay';
import PersistentDrawerLeft from '@/components/SideBar/PersistentDrawerLeft';
import PreferencesProvider from '@/context/PreferencesProvider';

const HomePage = () : React.ReactElement => {
    return (
        <>
            <AuthenticatedTemplate>
                <PreferencesProvider categories={['dashboard', 'scheduler', 'capacity']}>
                    <PersistentDrawerLeft/>
                </PreferencesProvider>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <LoginDisplay/>
            </UnauthenticatedTemplate>
        </>
    );
};

export default HomePage;
